import firebase from "config/firebase";
import { toast } from "react-toastify";
export const getUsers = () => {
  return async (dispatch) => {
    firebase
      .firestore()
      .collection("users")
      .where("role", "==", "fan")
      .onSnapshot((query) => {
        var fans = [];
        query.forEach((doc) => {
          fans.push({ id: doc.id, ...doc.data() });
        });
        dispatch({
          type: "GET_USERS",
          payload: fans,
        });
      });
  };
};

export const getAllUsers = () => async (dispatch) => {
  firebase
    .firestore()
    .collection("users")
    .onSnapshot((query) => {
      let allUser = [];
      query.forEach((doc) => {
        allUser.push({ id: doc.id, ...doc.data() });
      });
      dispatch({ type: "GET_ALL_USERS", payload: allUser });
    });
};
